"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefinitionOfTokenCollectionOnNetwork = exports.DefinitionOfFungibleTokenOnNetwork = void 0;
const bignumber_js_1 = require("bignumber.js");
const address_1 = require("../address");
class DefinitionOfFungibleTokenOnNetwork {
    constructor() {
        this.identifier = "";
        this.name = "";
        this.ticker = "";
        this.owner = new address_1.Address();
        this.decimals = 0;
        this.supply = new bignumber_js_1.BigNumber(0);
        this.isPaused = false;
        this.canUpgrade = false;
        this.canMint = false;
        this.canBurn = false;
        this.canChangeOwner = false;
        this.canPause = false;
        this.canFreeze = false;
        this.canWipe = false;
        this.canAddSpecialRoles = false;
    }
    static fromApiHttpResponse(payload) {
        let result = new DefinitionOfFungibleTokenOnNetwork();
        result.identifier = payload.identifier || "";
        result.name = payload.name || "";
        result.ticker = payload.ticker || "";
        result.owner = new address_1.Address(payload.owner || "");
        result.decimals = payload.decimals || 0;
        result.supply = new bignumber_js_1.BigNumber(payload.supply || "0");
        result.isPaused = payload.isPaused || false;
        result.canUpgrade = payload.canUpgrade || false;
        result.canMint = payload.canMint || false;
        result.canBurn = payload.canBurn || false;
        result.canChangeOwner = payload.canChangeOwner || false;
        result.canPause = payload.canPause || false;
        result.canFreeze = payload.canFreeze || false;
        result.canWipe = payload.canWipe || false;
        result.canAddSpecialRoles = payload.canAddSpecialRoles || false;
        return result;
    }
}
exports.DefinitionOfFungibleTokenOnNetwork = DefinitionOfFungibleTokenOnNetwork;
class DefinitionOfTokenCollectionOnNetwork {
    constructor() {
        this.collection = "";
        this.type = "";
        this.name = "";
        this.ticker = "";
        this.owner = new address_1.Address();
        this.decimals = 0;
        this.canPause = false;
        this.canFreeze = false;
        this.canWipe = false;
        this.canTransferRole = false;
    }
    static fromApiHttpResponse(payload) {
        let result = new DefinitionOfTokenCollectionOnNetwork();
        result.collection = payload.collection || "";
        result.type = payload.type || "";
        result.name = payload.name || "";
        result.ticker = payload.ticker || "";
        result.owner = new address_1.Address(payload.owner || "");
        result.decimals = payload.decimals || 0;
        result.canPause = payload.canPause || false;
        result.canFreeze = payload.canFreeze || false;
        result.canWipe = payload.canWipe || false;
        result.canTransferRole = payload.canTransferRole || false;
        return result;
    }
}
exports.DefinitionOfTokenCollectionOnNetwork = DefinitionOfTokenCollectionOnNetwork;
//# sourceMappingURL=tokenDefinitions.js.map